import {
  Box,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  Avatar,
  Portal,
} from '@chakra-ui/react';
import { CenterSpinner } from '@/components/ats';
import type { RefObject } from 'react';
import { useGetInterviewerPool, type InterviewerPoolUser } from '@/api';

const PoolMemberRow = ({
  interviewer,
}: {
  interviewer: InterviewerPoolUser;
}) => (
  <Flex gap="8px" borderRadius="xs" bg="ats-secondary">
    <Avatar
      name={interviewer?.name}
      src={interviewer?.avatar_url}
      width="20px"
      height="20px"
      className="avatar-sm"
    />
    <Text fontSize="sm">{interviewer?.name}</Text>
  </Flex>
);

interface InterviewPoolPopoverProps {
  value?: number | string | null;
  containerRef?: RefObject<HTMLElement | null> | null;
}

export const InterviewPoolPopover = ({
  value,
  containerRef = null,
}: InterviewPoolPopoverProps) => {
  const { interviewerPool, isLoading } = useGetInterviewerPool({ id: value });
  const members = interviewerPool?.users ?? [];

  return (
    <Popover trigger="hover" isLazy placement="top">
      <PopoverTrigger>
        <Text color="ats-primary" size="sm-medium">
          View Pool
        </Text>
      </PopoverTrigger>
      <Portal containerRef={containerRef ?? undefined}>
        <PopoverContent width="200px" className="z-index-10000">
          <PopoverBody>
            <Box p="8px">
              <Text size="sm-medium">In this pool</Text>
              {isLoading ? (
                <CenterSpinner h="150px" />
              ) : (
                <Flex
                  flexDirection="column"
                  gap="8px"
                  my="md"
                  maxH="200px"
                  overflowY="auto"
                >
                  {members.map((interviewer) => (
                    <PoolMemberRow
                      interviewer={interviewer}
                      key={interviewer.id}
                    />
                  ))}
                </Flex>
              )}
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
